import EntityServise from "./entityService";
import http from '../util/ws/wsService.js'


class InMemoryService extends EntityServise {
    constructor() {
        super("inmemory")
    }

    async postValueVariable(variable, value) {
        return await http.post(`${this.routeApi}/variable?key=${variable}&value=${value}`);
    }

    async getValueVariable(variable) {
        return await http.get(`${this.routeApi}/variable`, { key: variable });
    }
}

export default new InMemoryService();